module.exports = __webpack_public_path__ + "static/example_1_day_with_task_list-07a15d481f0def7f9b3105f20a800dff.png";